import MicroModal from 'micromodal';

window.addEventListener('load', () => {
    const modalContainer = $('.consultants__content');
    const modalContainerPackages = $('.packages');

    if(modalContainer.length !==0 || modalContainerPackages.length !==0) {
        MicroModal.init({
            openTrigger: 'data-micromodal-open',
            closeTrigger: 'data-micromodal-close',
            openClass: 'is-open',
            disableScroll: false,
            disableFocus: true,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true
        });
    }
});

const packagesLinks = document.querySelectorAll('.packages-link-js');
const packModalName = document.querySelector('.micromodal__pack-name');
const packModalPrice = document.querySelector('.micromodal__pack-price span:last-child');
const hiddenInputPack = document.querySelector('.inputpack');
const hiddenInputPackPrice = document.querySelector('.inputpack-price');
const hiddenInputPackSubject = document.querySelector('.inputpack-subject');

packagesLinks.forEach(buttons => {
    buttons.addEventListener('click', button => {
        packModalName.innerHTML = button.currentTarget.dataset.name;
        packModalPrice.innerHTML = button.currentTarget.dataset.price;
        hiddenInputPack.value = button.currentTarget.dataset.name;
        hiddenInputPackPrice.value = button.currentTarget.dataset.price;
        hiddenInputPackSubject.value = document.querySelector('.js-form-subject-title').innerText;
    });
});

// Modal Package
document.addEventListener('wpcf7invalid', function( event ) {
    if ( '2581' == event.detail.contactFormId ) {
        const formPopup = document.querySelector('.form-popup--alert');
        const boxClose = document.querySelector('.form-popup--alert .form-popup__close');

        formPopup.style.cssText = `
            z-index: 11;
            // animation: scale-in-center 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
            // animation: slide-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
            animation: slide-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
        `;

        setTimeout(() => {
            formPopup.style.cssText = `
                z-index: -1;
                animation: none;
            `;
        }, 7000);

        boxClose.addEventListener('click', () => {
            formPopup.style.cssText = `
                z-index: -1;
                animation: none;
            `;
        });
    }
}, false );

document.addEventListener('wpcf7mailsent', function( event ) {
    const formGroup = document.querySelectorAll('.form-group');

    formGroup.forEach(group => {
        group.classList.remove('active');
    });

    if ( '2581' == event.detail.contactFormId ) {
        const formPopup = document.querySelector('.form-popup--success');
        const boxClose = document.querySelector('.form-popup--success .form-popup__close');

        formPopup.style.cssText = `
            z-index: 11;
            animation: slide-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
        `;

        setTimeout(() => {
            formPopup.style.cssText = `
                z-index: -1;
                animation: none;
            `;
        }, 7000);

        boxClose.addEventListener('click', () => {
            formPopup.style.cssText = `
                z-index: -1;
                animation: none;
            `;
        });
    }
}, false );

// Reset Form on close modal
const closePack = document.querySelector('.micromodal__close--pack');
const formsPopup = document.querySelectorAll('.form-popup');

if (closePack) {
    closePack.addEventListener('click', () => {
        document.querySelector('.wpcf7-form').reset();

        formsPopup.forEach(popup => {
            popup.style.cssText = `
                z-index: -1;
                animation: none;
            `;
        });
    });
}
